﻿import {MessageBoxService} from './messageBox.service';

export default angular.module('idi.core.messagebox', ['ui.bootstrap'])
    .service('messageBoxService', MessageBoxService)
    .name;
